import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import Alert from '../components/ui/Alert';

export default function OAuthCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Check for OAuth error parameters
        const urlParams = new URLSearchParams(window.location.search);
        const oauthError = urlParams.get('error');
        
        if (oauthError) {
          console.error('OAuth error:', oauthError);
          setStatus('error');
          setError(urlParams.get('error_description') || oauthError);
          setTimeout(() => navigate('/', { replace: true }), 3000);
          return;
        }

        // Wait for Amplify to process the OAuth callback
        // Amplify automatically exchanges the code for tokens
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Verify authentication
        const user = await getCurrentUser();
        await fetchAuthSession();
        
        console.log('OAuth successful, user:', user.userId);
        setStatus('success');
        
        // Redirect to dashboard
        setTimeout(() => navigate('/dashboard', { replace: true }), 1000);
        
      } catch (err) {
        console.error('OAuth callback error:', err);
        setStatus('error');
        setError(err.message);
        setTimeout(() => navigate('/', { replace: true }), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-8">
      <div className="text-center max-w-md">
        {status === 'error' ? (
          <>
            <Alert variant="error" className="mb-4">
              Authentication failed. Redirecting...
            </Alert>
            {error && <p className="text-sm text-gray-600 mt-2">{error}</p>}
          </>
        ) : (
          <>
            <LoadingSpinner size="lg" />
            <h2 className="mt-4 text-xl font-semibold text-gray-900">
              {status === 'success' ? 'Sign in successful!' : 'Completing sign in...'}
            </h2>
            <p className="mt-2 text-gray-600">
              {status === 'success' 
                ? 'Redirecting to your dashboard...' 
                : 'Please wait while we complete your authentication.'}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
